import { useTranslate } from '@repo/shared/hooks'
import { z } from 'zod'

export const useDepositCryptoSchema = (isCardRequired = true) => {
  const { t } = useTranslate()
  const schema = z.object({
    token: z.string({
      required_error: t('depositCryptoPage_token_required'),
    }),
    blockchain: z.string({
      required_error: t('depositCryptoPage_network_required'),
    }),
  })
  return { schema }
}

export type DepositCryptoFormValues = z.infer<
  ReturnType<typeof useDepositCryptoSchema>['schema']
>
